import {getButtonOutlineWhite} from '@hconnect/common/styles'
import {spawnErrorToast} from '@hm/fundamental'
import {FileDownload} from '@mui/icons-material'
import {Button, CircularProgress} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useExportJobsToBeDone} from '../hooks'

type JtbdExportButtonProps = {
  plantUpmId: string
  plantCode: string
  plantName: string
  associatedRole?: string
}

export const JtbdExportButton: React.FC<JtbdExportButtonProps> = ({
  plantUpmId,
  plantCode,
  plantName,
  associatedRole
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const handleExportError = () => {
    spawnErrorToast(t('jobsToBeDone.message.failedToExport'))
  }

  const {mutate: exportJobsToBeDone, isPending} = useExportJobsToBeDone(
    {
      plantUpmId,
      plantCode,
      plantName
    },
    {
      onError: handleExportError
    }
  )

  return (
    <Button
      variant="outlined"
      data-test-id="jtbd-export-button"
      startIcon={isPending ? <CircularProgress size={16} color="inherit" /> : <FileDownload />}
      disabled={isPending}
      onClick={() => exportJobsToBeDone({associatedRole})}
      sx={(theme) => getButtonOutlineWhite(theme)}
    >
      {t('jobsToBeDone.label.export')}
    </Button>
  )
}
